<template>
  <div class="animated fadeIn">
    <GeneralSpinner v-if="!tab_selected_energy && !analyzers_status && !generator_status && !pump_status"></GeneralSpinner>
    <div class="tabs-select-style col-md-12 mb-12">
      <ul class="nav nav-pills nav-fill">
        <li class="nav-item" v-if="analyzers_status">
          <a class="nav-link" v-bind:class="{ active: tab_selected_analyzer }" @click="clickNavTabs('analyzer')">
            {{web_texts.electric_params}}
          </a>
        </li>
        <li class="nav-item" v-if="generator_status">
          <a class="nav-link" v-bind:class="{ active: tab_selected_generator }" @click="clickNavTabs('generator')">
            {{web_texts.generator}}
          </a>
        </li>
        <li class="nav-item" v-if="pump_status">
          <a class="nav-link" v-bind:class="{ active: tab_selected_pump }" @click="clickNavTabs('pump')">
            {{web_texts.pump_well}}
          </a>
        </li>
      </ul>
    </div>
    <br>
    <div class="col-md-12 mb-12">
      <div v-if="tab_selected_analyzer">
        <AnalyzerStatus :devices="devices" :master_dev="master_dev"></AnalyzerStatus>
      </div>
      <div v-else-if="tab_selected_generator">
        <GeneratorStatus :devices="devices" :master_dev="master_dev"></GeneratorStatus>
      </div>
      <div v-else-if="tab_selected_pump">
        <PumpStatus :devices="devices" :master_dev="master_dev"></PumpStatus>
      </div>
      <div v-else-if="tab_selected_energy">
        <EnergyCounters :devices="devices" :master_dev="master_dev"></EnergyCounters>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Home';
  import trans_es from '../translates/es/Home';
  import constants from '../constants';
  import middleware from '../utilities/middlewares';
  import EnergyCounters from './partials/home_partials/EnergyCounters.vue';
  import AnalyzerStatus from './partials/home_partials/AnalyzerStatus.vue';
  import GeneratorStatus from './partials/home_partials/GeneratorStatus.vue';
  import PumpStatus from './partials/home_partials/PumpStatus.vue';
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: 'Home',
    data() {
      return {
        web_texts: { "electric_params": "Paràmetres Elèctrics", "generator": "Grup Electrogen", "pump_well": "Bomba-Bassa", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "current_power": "Pot. Actual", "status": "Estat", "current_active_power": "Potència Activa Instantània", "cos_phi": "Cosinus de Phi Instantani", "monthly_energy_consumed": "Històric anual d'energia consumida", "generator_status": "Estat Grup", "api_general": "Pot. General", "api_generator": "Pot. Grup", "current_tension": "Tensió actual", "active_power": "Potència activa", "active_power_now": "Potència Activa Instantània", "active_reactive_energy": "Energia activa reactiva", "Cos_phi": "Cosinus de phi", "monthly_active_power": "Històric potencia activa mensual", "pump_status": "Estat Bomba", "flow_pump": "Cabal Bomba", "counter_lecture": "Lec. Comptador", "vol_raft": "Niv. Bassa", "": "Històric activacions bomba", "historical_low_level": "Històric nivell bassa" } },
        system: '',
        devices: '',
        master_dev: '',
        energy_counters: false,
        analyzers_status: false,
        generator_status: false,
        pump_status: false,
        sele_optio: '',
        tab_selected_energy: false,
        tab_selected_analyzer: false,
        tab_selected_generator: false,
        tab_selected_pump: false
      }
    },
    components:{
      EnergyCounters,
      AnalyzerStatus,
      GeneratorStatus,
      PumpStatus,
      GeneralSpinner
    },
    created() {
      middleware.userIsLoged();
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      this.system = JSON.parse(window.localStorage.getItem('system'));
      this.haveAnalyzers();
    },
    methods: {
      // Opcions dels v-if amb la seleccio del TAB
      clickNavTabs(tab){
        switch (tab){
          case 'analyzer':
            this.tab_selected_analyzer=true;
            this.tab_selected_generator=false;
            this.tab_selected_pump=false;
            this.sele_optio='analyzer';
            break;
          case 'generator':
            this.tab_selected_generator=true;
            this.tab_selected_analyzer=false;
            this.tab_selected_pump=false;
            this.sele_optio='generator';
            break;
          case 'pump':
            this.tab_selected_pump=true;
            this.tab_selected_generator=false;
            this.tab_selected_analyzer=false;
            this.sele_optio='pump';
            break;
          default:
            console.log('Option not registered');
            break;
        }
      },
      // Llegir tots els dispositius i mirar si tenen generadors i si el sistema te algun master
      haveAnalyzers(){
        axios.post(constants.ROOT_URL + '/api/v1/get_devices', {
          system_id: this.system.id,
          client_device: 'd',
        }).then((response) => {
          var devices = response.data;
          this.devices=devices;
          this.analyzers_status = true;
          this.tab_selected_analyzer = true;
          this.sele_optio='analyzer';
          this.haveGenerator(devices);
          this.getMastersBySystem();

          //TODO Refactor this (done on mapei clima)
          if(this.system.id===20){
            this.analyzers_status = false;
            this.tab_selected_analyzer = false;

            this.tab_selected_energy = true
          }

        }, (response) => {
          this.getMastersBySystem();
          console.log(response);
        });
      },
      // Mirar si algun dispositiu te un generador
      haveGenerator(devices) {
        for (var i = 0; i < devices.length; i++) {
          if (devices[i].name.indexOf("Grup") > 0) {
            this.generator_status = true;
          }
        }
      },
      // Llegir els masters amb les seves bombes
      getMastersBySystem() {
        axios.post(constants.ROOT_URL + '/api/v1/get_masters', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.master_dev=response.data[0];
          this.havePump(response.data[0].id)
        }, (response) => {
          console.log(response)
        });
      },
      // Llegir les bombes dels masters
      havePump(master_id) {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: '[["' + master_id + '", "R$EVE_E_Bomba_ON.ST", "R$EVE_E_Bomba_OFF.ST", "R$EVE_Selector_ON.ST", "R$EVE_Selector_OFF.ST", "R$EVE_Selector_AUT.ST" ,"R$EVE_APP_Bomba_Poweroff_AUT.ST"]]'
        }).then((response) => {
          this.sele_optio='pump';
          this.pump_status = true;
          if (!this.tab_selected_analyzer) {
            this.tab_selected_pump = true;
          }
        }, (response) => {
          console.log(response)
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?246377a9